// extracted by mini-css-extract-plugin
export default {"textarea":"Xjv3jP","standard":"b5xEgg","errored":"ZmS4cV"};